import React from 'react';
import { Canvas } from '@react-three/fiber';
import Experience from './Experience';
import './style.css';

function App() {
  return (
    <Canvas>
      <Experience />
    </Canvas>
  );
}

export default App;
